export const REACTIONS_KEYS = {
  '-1': 'dislike',
  '1': 'like',
  '2': 'fire',
  '3': 'smile',
  '4': 'think',
  '5': 'cry',
  '6': 'scream',
  '7': 'bookmark',

  'dislike': '-1',
  'like': '1',
  'fire': '2',
  'smile': '3',
  'think': '4',
  'cry': '5',
  'scream': '6',
  'bookmark': '7',
}